import { partiesKeywords } from "../../pages/FormPage/specialFields";
import { isEmptyObject, sortObjectByKeys } from "../../utils/utilities";


export const stateActions = {
    updateAgentDetails: (data) => {
        const agentDetails = data.Agent;
        
        return agentDetails;
        
    },
    updateFormTypeState: (data, mainForm) => {

        return { 
            form: data.Form, 
            type: data.Type, 
            fields: mainForm.Fields?.length > 0 ? mainForm.Fields : [] ,
            sections: mainForm.Sections?.length > 0 ? mainForm.Sections : []
        }
    },
    updateSelectedTemplatesState: (data) => {
        const formVals = data.SelectedTemplates;
        return formVals ?? []
    },
    updateSharedFormsState: (data) => {
        const formVals = data.SharedForms;
        return formVals ?? []
    },
    updateSupportingDocsState: (data) => {
        const formVals = data.SupportingDocuments;
        return formVals ?? []
    },
    updateFormAndErrorState: (data) => {
        //init form State
        const formState = data.Values;
        //set main error state
        const mainKey = Object.keys(formState.mainValues);
        // new main values, set to " " each property
        const newMainObj = Object.fromEntries(mainKey.map(key => [key, ""]));

        // new object for error state
        const newErrObject = { mainValues: newMainObj }

        //form state and form errors state
        return {
            formErrors: newErrObject,
            formState: formState
        };
    },
    updatePartiesFieldsCount: (mainValues, defaultValues) => {

        const sortedByKeys = sortObjectByKeys(mainValues); //sort by object property name
        
        const newObj = {}
        // Process each key-value pair in the sorted object
        for (const [key, value] of Object.entries(sortedByKeys)) {
            // Check if the key contains any "party" keywords (buyer, seller) and includes 'name'
            const partyField = partiesKeywords.find(party => key.toLowerCase().includes(party) && key.toLowerCase().includes('name'));

            if (partyField) {
                // Extract the number from the key
                const match = key.match(/\d+/);
                if (match) {
                    const keyNumber = parseInt(match[0], 10);
                    // Check if the key number is greater than 4 and the value is non-empty
                    if (keyNumber > 1 && value) {
                        newObj[partyField] = keyNumber;
                    }
                }
            }
        }

        if (isEmptyObject(newObj)) {
            return defaultValues
        }

        return {...defaultValues , ...newObj};
    },
    updateSignatoriesState: (data) => {
            const formVals = data.FormSignatories ? data.FormSignatories : [];
            return formVals;
    },
}